/**
 * What a listing says about the car beyond make and model: its body, gearbox and fuel (mirror of
 * the api's `BodyType`, `Gearbox` and `Fuel`; the values are decision №37). The same three lists
 * stand in the dealer cabinet's forms — a word here is the word the dealer picked there.
 */
export enum BodyType {
  SEDAN = 'sedan',
  HATCHBACK = 'hatchback',
  ESTATE = 'estate',
  SUV = 'suv',
  COUPE = 'coupe',
  CONVERTIBLE = 'convertible',
  MINIVAN = 'minivan',
  PICKUP = 'pickup',
  VAN = 'van',
}

export enum Gearbox {
  MANUAL = 'manual',
  AUTOMATIC = 'automatic',
}

export enum Fuel {
  PETROL = 'petrol',
  DIESEL = 'diesel',
  HYBRID = 'hybrid',
  PLUG_IN_HYBRID = 'plug-in-hybrid',
  ELECTRIC = 'electric',
  LPG = 'lpg',
}

export const BODY_TYPE_LABELS: Record<BodyType, string> = {
  [BodyType.SEDAN]: 'Sedan',
  [BodyType.HATCHBACK]: 'Hatchback',
  [BodyType.ESTATE]: 'Estate',
  [BodyType.SUV]: 'SUV',
  [BodyType.COUPE]: 'Coupe',
  [BodyType.CONVERTIBLE]: 'Convertible',
  [BodyType.MINIVAN]: 'Minivan',
  [BodyType.PICKUP]: 'Pickup',
  [BodyType.VAN]: 'Van',
};

export const GEARBOX_LABELS: Record<Gearbox, string> = {
  [Gearbox.MANUAL]: 'Manual',
  [Gearbox.AUTOMATIC]: 'Automatic',
};

export const FUEL_LABELS: Record<Fuel, string> = {
  [Fuel.PETROL]: 'Petrol',
  [Fuel.DIESEL]: 'Diesel',
  [Fuel.HYBRID]: 'Hybrid',
  [Fuel.PLUG_IN_HYBRID]: 'Plug-in hybrid',
  [Fuel.ELECTRIC]: 'Electric',
  [Fuel.LPG]: 'LPG',
};

/**
 * The three attributes as a listing of either vertical carries them. All three are the dealer's to
 * leave empty (`null`), and all three are optional here: an api that predates them sends none, and
 * a screen must read that the same way — the dealer has not said.
 */
export interface CarAttributes {
  bodyType?: BodyType | null;
  gearbox?: Gearbox | null;
  fuel?: Fuel | null;
}
